module.exports = __webpack_public_path__ + "images/icons_v2/juul-pod-green-e5627cc8.svg";